import axios from "axios";
import { serviceUrl } from "../../config";
import { checkSessionIsActive, getSessionData } from "../utilfunctions/utilFunctions";
import { resetSession } from "./sessions";

const BACKEND_URL = serviceUrl;

export const getPortalUsers = async () => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "Listsubusers",
      dat: {},
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const disableUser = async (userid, list) => {
  const sessionData = getSessionData();
  let disable = `status|${list}`;

  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "EditUserFieldsWithoutPIN",
      dat: {
        userid: userid,
        list: disable,
      },
    });

    console.log(data)

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const changeUserDetails = async (userid, list) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "EditUserFieldsWithoutPIN",
      dat: {
        userid: userid,
        list: list,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getSystemStatus = async () => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "getSystemStatus",
      dat: {},
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const changemmerchantdetails = async (userid, list, fielddelimiter = "/", datadelimiter = "|", location = "", userpin = "", pinrequired = 0) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "UpdateMerchantProfileFields5",
      dat: {
        location: location,
        userid: userid,
        userpin: userpin,
        pinrequired: pinrequired,
        list: list,
        fielddelimiter: fielddelimiter,
        datadelimiter: datadelimiter,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getProfileStatus = async () => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "getProfileStatus",
      dat: {},
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const updateStatus = async (
  userid,
  list,
  fielddelimiter,
  datadelimiter
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "updateStatus",
      dat: {
        userid: userid,
        list: list,
        fielddelimiter: fielddelimiter,
        datadelimiter: datadelimiter,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const listSystemRoles = async () => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "listSystemRoles",
      dat: {},
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ListUserAssignedRoles = async (userid) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "ListUserAssignedRoles",
      dat: {
        userid: userid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const AssignDeassignRoles = async (
  merchantid,
  roleid,
  action
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "AssignDeassignRoles",
      dat: {
        merchantid: merchantid,
        roleid: roleid,
        action: action,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const TermsAndConditionsAPI = async () => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "tandc",
      dat: {},
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const GetProfileBalance = async (userid) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "GetBalances",
      dat: {
        userid: userid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const SendEmailWithFrom = async (
  destinationEmail,
  subject,
  emailText
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "SendEmailWithFrom",
      dat: {
        destinationEmail: destinationEmail,
        subject: subject,
        emailText: emailText,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const changeUsername = async (
  oldusername,
  PIN,
  userid,
  newusername,
  agentID,
  countryid,
  login,
  agentusername,
  countryflag
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "changeUsernameNew",
      // pid: "changeUsername",
      dat: {
        oldusername: oldusername,
        PIN: PIN,
        userid: userid,
        newusername: newusername,
        agentID: agentID,
        countrycode: countryid,
        login: login,
        agentusername: agentusername,
        countryflag: countryflag
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const changeUsernameVerifyCode = async (
  oldusername,
  PIN,
  userid,
  newusername,
  agentID,
  countryid,
  login,
  agentusername,
  verificationCode,
  countryflag,
  deviceid,
  currentphoneno
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "changeUsernameVerifyCode",
      // pid: "changeUsername",
      dat: {
        oldusername: oldusername,
        PIN: PIN,
        userid: userid,
        newusername: newusername,
        agentID: agentID,
        countrycode: countryid,
        login: login,
        agentusername: agentusername,
        verificationcode: verificationCode,
        countryflag: countryflag,
        _deviceToken: deviceid,
        currentphoneno: currentphoneno
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const adminChangePasswordPin = async (
  unlock,
  username,
  pin,
  onlypin,
  password,
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "Change",
      dat: {
        unlock: unlock,
        username: username,
        pin: pin,
        onlypin: onlypin,
        password: password
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const GetListOfPaymentInstruments = async (userid) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "GetListOfPaymentInstruments",
      dat: {
        userid: userid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getProgramsForAccountingModule = async () => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "getSourceAccounts",
      dat: {},
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const postAccountingModuleAdjustment = async (
  paycontrolaccountno,
  thisdepositamount,
  muid,
  programaccountno,
  PIN,
  defaultcurrencycode,
  thisadjustmentreason,
  thisposttype
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "DepositProgramFunds",
      dat: {
        paycontrolaccountno: paycontrolaccountno,
        thisdepositamount: thisdepositamount,
        muid: muid,
        programaccountno: programaccountno,
        PIN: PIN,
        defaultcurrencycode: defaultcurrencycode,
        thisadjustmentreason: thisadjustmentreason,
        thisposttype: thisposttype
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const changeUserStatus = async (userid, list, status) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "changeUserStatus",
      dat: {
        userid: userid,
        list: list,
        status: status
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const removeBusinessProfile = async (userid) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "removeBusinessProfile",
      dat: {
        userid: userid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const activeInactiveMerchant = async (location, merchantid, active) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "ActiveInactiveMerchant",
      dat: {
        location: location,
        merchantid: merchantid,
        active: active
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const userAddUpdateAppAccess = async (userid, appid) => {
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "userAddUpdateAppAccess",
      dat: {
        location: "",
        userid: userid,
        appid: appid,
        appstatus: 1
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const addUpdateExchangeRate = async (sourcecurrency, destinationcurrency, rate, active, lastupdateby) => {
  try {
    const data = JSON.stringify({
      svc: "admin",
      pid: "addUpdateExchangeRate",
      dat: {
        location: "",
        sourcecurrency: sourcecurrency,
        destinationcurrency: destinationcurrency,
        rate: rate,
        active: active,
        lastupdateby: lastupdateby
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const updateUserEmail = async (userid, email, firstName, lastName, authUserId) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "UpdateUserEmail",
      dat: {
        userid: userid,
        email: email,
        firstName: firstName,
        lastName: lastName,
        authUserId: authUserId
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
